// extracted by mini-css-extract-plugin
module.exports =  {"stopBuild":"StopBuild-module__stopBuild--KS","iconOnly":"StopBuild-module__iconOnly--SE","invisible":"StopBuild-module__invisible--Fw"};